var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBaseball(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_472_6758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6885 16.1985C21.9295 17.0946 21.5156 18.2184 21.5156 19.4061C21.5156 20.5924 21.9371 21.7264 22.6921 22.6181C23.5011 21.7907 23.9999 20.6588 23.9999 19.4102C23.9999 18.1598 23.4996 17.0264 22.6885 16.1985Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0976 22.5871C16.8423 21.6954 17.248 20.582 17.248 19.4061C17.248 18.2371 16.8372 17.1164 16.1011 16.2299C15.308 17.0548 14.8203 18.1755 14.8203 19.4102C14.8203 20.6432 15.3065 21.7624 16.0976 22.5871Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5661 23.4628C20.6309 22.329 20.1095 20.9001 20.1095 19.4061C20.1095 17.9105 20.6209 16.4936 21.5607 15.3548C20.9191 15.0139 20.1873 14.8205 19.4102 14.8205C18.6168 14.8205 17.8705 15.0218 17.2194 15.3761C18.1408 16.5061 18.6544 17.9258 18.6544 19.4061C18.6544 20.8951 18.1476 22.3061 17.2158 23.4423C17.8677 23.7979 18.6153 24 19.4102 24C20.1895 24 20.9233 23.8055 21.5661 23.4628Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.237 0.763222C22.2194 -0.254387 20.5696 -0.254387 19.552 0.763222L14.8915 5.42372C14.3248 5.99035 13.7817 6.57989 13.2632 7.19091L10.0745 11.382C9.65066 11.939 9.20755 12.4812 8.74311 13.0048C8.4297 13.3581 8.11161 13.7072 7.78906 14.0522L9.94808 16.2113C10.293 15.8887 10.6422 15.5706 10.9955 15.2572C11.519 14.7928 12.0612 14.3497 12.6183 13.9259L16.8094 10.7371C17.4204 10.2187 18.0099 9.67547 18.5765 9.10885L23.237 4.44835C24.2547 3.43069 24.2547 1.78083 23.237 0.763222Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.81524 15.0671C6.7139 15.1701 6.61246 15.273 6.51032 15.3752L3.59863 18.2869C3.89057 18.4445 4.16132 18.6453 4.40249 18.8865L5.11373 19.5977C5.35495 19.8389 5.55571 20.1096 5.71335 20.4015L8.62504 17.4899C8.72723 17.3877 8.83012 17.2863 8.9331 17.1849L6.81524 15.0671Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.17991 23.8901L0.109828 20.8201C-0.0366094 20.6736 -0.0366094 20.4361 0.109828 20.2897L0.518719 19.8808C1.31653 19.083 2.61005 19.083 3.40786 19.8808L4.11909 20.5921C4.91691 21.3899 4.91691 22.6834 4.11909 23.4812L3.7102 23.8901C3.56381 24.0366 3.32634 24.0366 3.17991 23.8901Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_472_6758"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaseball);
export default __webpack_public_path__ + "static/media/baseball.117491a1def23f8e46423eccbc22c467.svg";
export { ForwardRef as ReactComponent };